import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { isAuth } from '@entities';
import { BASE_URL } from '@app/routes';

const ProtectedRouteComponent = ({children}) => {
  const isUserAuth = useSelector(isAuth);

  if (!isUserAuth) {
    localStorage.setItem('fullpath', window.location.pathname + window.location.search);
  }

  return isUserAuth ? children : (<Navigate to={ BASE_URL.pathname + '#login' } replace />);
};

export default ProtectedRouteComponent;
